/**
 * Sections whose fields/images are reset when the vehicle type changes.
 * Shared between valuationStore (dirty tracking) and FieldInput (confirmation gating)
 * so both stay in sync on what counts as "vehicle-specific" data.
 */
export const VEHICLE_TYPE_SECTIONS = ['standard-equipment', 'additional-options', 'body-information', 'vehicle-condition']
